<template>
  <v-app class="responsive" id="layout">
    <!-- topbar -->
    <v-app-bar 
      app 
      clipped-left
      fixed
      elevation="2"
      color="app_bar_bg"
      v-if="!isScreenFull"
      id="layoutAppBar">
      <v-app-bar-nav-icon @click="isDrawer" color="app_bar_title" />
      <div class="main-title">HD Hyundai Vietnam Internet Procurement System</div>

      <!-- <div class="mr-5" v-if="$vuetify.theme.dark">
        <v-img :src="require(`@/assets/images/ci/iwelding_logo.png`)" width="130" contain to="#" @click="goHome()"
          style="cursor: pointer" />
      </div>-->
      <!-- <v-img
        :src="require(`@/assets/images/ci/header_ko_ci.png`)"
        max-width="130"
        height="50px"
        contain
        to="#"
        @click="goHome()"
        class="mr-19"
        style="cursor: pointer"
      /> -->

      <!-- menu -->
      <v-toolbar-items class="hidden-sm-and-down">
        <template>
          <!-- <div v-if="item.items" :key="item.icon">
            <v-menu offset-y>
              <template v-slot:activator="{ attrs, on }">
                <v-btn tile class="elevation-0 px-5 font-weight-bold" height="100%" v-bind="attrs" v-on="on"
                  color="transparent app_bar_title--text" active-class="primary lighten-1">
                  <v-icon v-if="item.icon" class="mr-2">
                    {{ item.icon }}
                  </v-icon>
                  {{ $t(item.title) }}
                </v-btn>
              </template>
              <v-list color="menu_bg">
                <v-list-item v-for="sub_item in item.items" :key="sub_item.icon" :to="sub_item.to"
                  active-class="primary lighten-1">
                  <v-list-item-title class="menu_title--text">{{ $t(sub_item.title) }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>-->
          <!-- <div v-else :key="item.icon"> -->
          <v-btn-toggle v-model="toggleBtn" class="filters-group" @change="fnChangeBtn">
            <div v-for="(item) in menuData" :key="item.sortFlag">
              <v-btn
                tile
                :key="item.sortFlag"
                @click="menuClick(item.menuCode)"
                :value="item.menuCode"
                class="elevation-0 px-5 font-weight-bold"
                height="100%"
                color="transparent app_bar_title--text"
                active-class
              >
                <v-icon v-if="item.icon" class="mr-2">${{ item.icon }}</v-icon>
                <!--  {{ $t(item.menuCode) }} -->
                {{ item.menuName }}
              </v-btn>
            </div>
          </v-btn-toggle>
        </template>
      </v-toolbar-items>
      <v-spacer />
      <!-- <iButton :text="'Home'" style="text-transform: unset !important;" />
      <iButton :text="'Notice'" style="text-transform: unset !important;" class="mr-2" /> -->
      <v-icon color="app_bar_title" class="pa-2" @click="changeFullscreen">$fullscreen</v-icon>
      <!-- i18n -->
      <!-- <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" text color="menu_title" class="pa-2">
            <img :src="activeLang.image" width="20" />
          </v-btn>
        </template>
        <v-list dense color="menu_bg">
          <v-list-item
            v-for="(lang, index) in langs"
            :key="index"
            @click="langClick(lang)"
            color="menu_title"
          >
            <v-list-item-title>
              <img :src="lang.image" width="20" />
              {{ lang.name }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu> -->

      <!-- <v-switch v-model="$vuetify.theme.dark" class="ml-3" @change="changeTheme($vuetify.theme.dark)">
      </v-switch>-->

      <div class="text-center">
        <v-menu offset-y min-width="180">
          <template v-slot:activator="{ on }">
            <v-btn icon large v-on="on">
              <v-icon color="app_bar_title">$person</v-icon>
            </v-btn>
          </template>
          <v-list class="text-center px-2" id="my-info" color="menu_bg menu_title--text">
            <v-avatar color="secondary darken-2" class="mb-2">
              <span class="menu_title--text text-h6">{{ user.initials }}</span>
            </v-avatar>
            <h3>{{ user.fullName }}</h3>
            <p class="text-caption mt-1">{{ user.makerNm }}</p>
            <!-- <v-divider class="my-1"></v-divider>
            <v-btn depressed rounded text class="px-3">
              <v-badge :content="mailCount" color="error" overlap height="100%">
                <v-icon color="menu_title">$mail</v-icon>
              </v-badge>
            </v-btn>
            <v-divider class="my-1"></v-divider>
            <v-btn depressed rounded text class="px-3" color="menu_title" to='/myPage'>
              나의정보
            </v-btn>-->
            <v-divider class="my-1"></v-divider>
            <v-btn depressed rounded text class="px-3" color="menu_title" @click="logout()">Logout</v-btn>
            <!-- <v-divider class="my-1"></v-divider>
            <v-btn depressed rounded text class="px-3" color="menu_title" to="/help">
              <v-icon>$info</v-icon>도움말
            </v-btn> -->
          </v-list>
        </v-menu>
      </div>
    </v-app-bar>

    <!-- navbar -->
    <v-navigation-drawer
      v-bind="$attrs"
      app
      clipped
      floating
      class="elevation-8"
      v-model="drawer"
      color="nav_bg"
    >
      <v-list nav expand>
        <template v-for="(item, index) in menuTreeData">
          <default-list-group v-if="item.children" :key="`group-${index}`" :item="item" class="pb-1"/>
          <default-list-item
            v-else
            :key="`item-${index}`"
            :item="item"
            style="background-color: #F2F6F1;"
          />
        </template>
      </v-list>
    </v-navigation-drawer>

    <!-- theme Generater -->
    <!-- <v-layout hidden-md-and-down>
      <v-btn fab small color="primary" app fixed right bottom @click.stop="drawerTheme = !drawerTheme">
        <v-icon>$setting</v-icon>
      </v-btn>
      <v-navigation-drawer width="600" app right floating temporary overlay-opacity="0" v-model="drawerTheme"
        color="nav_bg">
        <theme-generator />
      </v-navigation-drawer>
    </v-layout>-->

    <!-- mainview -->
    <v-main
      class="fill-height container_bg content--text"
      id="mainContent"
    > <!-- :class="drawer?'line-draw':'line-draw2'" -->
      <!--태그 뷰 v-if="needTagsView" -->
      <tags-view v-if="!isScreenFull"/>
      <router-view />
      <VueToastify :notifyAction="notifyAction"></VueToastify>
    </v-main>
  </v-app>
</template>

<script>
import ResizeMixin from '@/layout/mixin/ResizeHandler'
import { mapState } from 'vuex'

import { fn_Logout } from '@/framework/login/login'
import DefaultListItem from '@/layout/navbar/ListItem' // 단일 메뉴
import DefaultListGroup from '@/layout/navbar/ListGroup' // 그룹 메뉴
//import ThemeGenerator from '@/layout/ThemeGenerator.vue' // 테마
import TagsView from '@/layout/tagview'
import VueToastify from '@/components/toastify/VueToastify.vue'

import { getUserId, getComCode } from '@/utils/token'
import localStore from '@/utils/localStore'
import { thistle } from 'color-name'
import iButton from '@/components/common/iButton'

export default {
  name: 'DefaultLayout',
  components: {
    DefaultListItem,
    DefaultListGroup,
    //ThemeGenerator,
    TagsView,
    VueToastify,
    iButton
  },
  mixins: [ResizeMixin],
  data: () => ({
    // i18n
    languageMenu: true,
    activeLang: '',
    langs: [
      {
        id: 'ko',
        name: '한국어',
        image: require('@/assets/images/flags/ko.png')
      },
      {
        id: 'en',
        name: 'English',
        image: require('@/assets/images/flags/en.png')
      }
    ],
    // main
    drawer: true,
    drawerTheme: false,
    toggleBtn: '11',
    menuBtn: '',
    // app-bar
    dialog: false,
    user: {
      initials: '',
      fullName: '',
      email: ''
    },
    userInfo: null,
    // userInfo: {
    //   comCode: getComCode(),
    //   userId: getUserId(),
    //   lanCode: localStore.get('locale')
    // },
    mailCount: 124
  }),
  created() {
    let initial = ''
    const arrName = this.$store.state.user.userNm.split(' ')
    for(let i = 0; i < arrName.length; i++) {
      initial += arrName[i].substr(0, 1)
    }

    this.user = {
      initials: initial,
      fullName: this.$store.state.user.userNm,
      makerNm: this.$store.state.user.makerNm
    }

    this.userInfo = {
      userId: this.$store.state.user.userId,
      sysCd: this.$store.state.system.sysCd,
      sysId: this.$store.state.system.sysId
    }

    this.setLocale()

    this.$EventBus.$on('App_Bar_MenuClick', e => {
      this.menuClick(e)
    })
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
  },
  computed: {
    ...mapState({
      sidebar: state => state.app.sidebar,
      device: state => state.app.device,
      showSettings: state => state.settings.showSettings,
      needTagsView: state => state.settings.tagsView,
      fixedHeader: state => false, //state.settings.fixedHeader
      isScreenFull: state => state.app.isScreenFull
    }),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    },
     menuData() {
      return this.$store.state.menu.menus
    },
    menuTreeData() {
      // console.log('this.$store.state.menu.treeMenus', this.$store.state.menu.treeMenus)
      // return this.$store.state.menu.subTreeMenus
      return this.$store.state.menu.treeMenus
    },
    // drawer: {
    //   get () {
    //       return this.sidebar.opened
    //   },
    //   set (value) {
    //     this.sidebar.opened = value
    //   }
    // }
  },
  methods: {
    isDrawer() {
      this.drawer = !this.drawer
    },
    // 기존 ESG 소스 ('로딩중..' 표시 기능)
    notifyAction(notifyInfo, action) {
      // console.log('notifyAction',notifyInfo)
      // console.log('notifyAction',action)
      // console.log('notifyAction',this.$route.meta.menu_id)
      this.$EventBus.$emit(`${this.$route.meta.menu_id}_notifyAction`, { notifyInfo: notifyInfo, action: action })
    },
    fnChangeBtn(e) {
      //console.log('fnChangeBtn : ',e)
    },
    changeFullscreen() {
      this.drawer = false

      document.documentElement.requestFullscreen()
    },
    // 윈도우의 가로 크기를 담을 변수
    handleResize(e) {
      
      this.windowWidth = window.innerWidth;
      // console.log('handleResize window', window.innerHeight)
      // console.log('handleResize screen', screen.height)
      //풀스크린 여부
      this.$store.dispatch('app/setIsScreenFull', window.innerHeight == screen.height)
    },
    menuClick(menuCode) {
      this.$store.dispatch('app/openSideBar', true)
      this.toggleBtn = this.menuCode = menuCode
      //console.log('menuClick toggleBtn : ',this.toggleBtn)
      if (menuCode.trim() != '') {
        let clickMenuTreeData = []
        this.$store.state.menu.treeMenus.find(element => {
          if (element.moduleCode == menuCode) {
            clickMenuTreeData.push(element)
          }
        })
        this.$store.dispatch('GetSubMenus', clickMenuTreeData)
      }

      this.drawer = true
    },
    setLocale() {
      // if (this.$localStore.get('locale') == 'ko') {
      //   this.activeLang = this.$envs.framework.supportLocales.ko
      //   this.$vuetify.lang.current = 'ko'
      //   this.$i18n.locale = 'ko'
      // } else {
        this.activeLang = this.$envs.framework.supportLocales.en
        this.$vuetify.lang.current = 'en'
        this.$i18n.locale = 'en'
      // }
      this.$store.dispatch('GetMenus', this.userInfo)
      this.$EventBus.$emit('lanCode', this.$localStore.get('locale'))
    },
    langClick(lang) {
      this.activeLang = lang
      this.userInfo.lanCode = lang.id 
      this.$store.dispatch('GetMenus', this.userInfo)
      if (lang.id == 'ko') {
        this.$localStore.set('locale', 'ko')
        this.$vuetify.lang.current = 'ko'
        this.$i18n.locale = 'ko'
      } else {
        this.$localStore.set('locale', 'en')
        this.$vuetify.lang.current = 'en'
        this.$i18n.locale = 'en'
      }
      this.$EventBus.$emit('lanCode', lang.id)
    },
    // 로그아웃
    logout() {
      fn_Logout()
    },
    changeTheme(theme) {
      if (theme) {
        this.$localStore.set('theme', 'dark')
      } else {
        this.$localStore.set('theme', 'light')
      }
    },
    goHome() {
      this.$router.push('/epms0100')
    },
    isVisibleLayout(layout) {
      return this.$store.state.menu.flag[layout] || !this.$store.state.menu.flag.isLayoutHideMode
    }
  }
}
</script>
<style lang="scss" scoped>
.theme--light.v-btn-toggle:not(.v-btn-toggle--group) {
  background: #455b59;
  color: rgba(0, 0, 0, 0.87);
}
// Menu 상단 크기 강제 조절
/* .v-application--wrap {
  header {
    height: 45px !important;
    ::v-deep .v-toolbar__content {
      height: 45px !important;
    }
  }
  //사이드바 크기 조절
  nav {
    top: 45px !important;
    max-height: calc(100% - 45px) !important;
  }
  //Main 크기 조절
} */
//side bar group header 색상 변경
::v-deep .v-list-group__header {
  background: #f2f6f1 !important;
  padding-left: 10px !important;
}

.main-title{
  width : 100%;
  text-align: center;
  color : white;
  font-weight: bold;
}
/* .line-draw {
  padding: 42px 0px 0px 256px !important;
}
.line-draw2 {
  padding: 42px 0px 0px 0px !important;
} */
</style>